<script setup>
defineProps({
  userSearch: String,
  selectedRoleFilter: String,
  selectedOrgFilter: String,
  selectedSubOrgFilter: String,
  selectedLifecycleFilter: String,
  listPageSize: [String, Number],
  roleFilterOptions: { type: Array, default: () => [] },
  orgFilterOptions: { type: Array, default: () => [] },
  subOrgFilterOptions: { type: Array, default: () => [] },
})

const emit = defineEmits([
  'update:userSearch',
  'update:selectedRoleFilter',
  'update:selectedOrgFilter',
  'update:selectedSubOrgFilter',
  'update:selectedLifecycleFilter',
  'update:listPageSize',
])
</script>

<template>
  <div class="panel filters-bar">
    <input :value="userSearch" type="search" class="form-control" placeholder="Search username or email" data-testid="users-search" @input="emit('update:userSearch', $event.target.value)" />
    <select :value="selectedRoleFilter" class="form-select" data-testid="users-role-filter" @change="emit('update:selectedRoleFilter', $event.target.value)">
      <option value="all">All roles</option>
      <option v-for="role in roleFilterOptions" :key="role" :value="role">{{ role }}</option>
    </select>
    <select :value="selectedOrgFilter" class="form-select" data-testid="users-org-filter" @change="emit('update:selectedOrgFilter', $event.target.value)">
      <option value="all">All organizations</option>
      <option v-for="org in orgFilterOptions" :key="org.id" :value="String(org.id)">{{ org.name }}</option>
    </select>
    <select :value="selectedSubOrgFilter" class="form-select" data-testid="users-suborg-filter" @change="emit('update:selectedSubOrgFilter', $event.target.value)">
      <option value="all">All suborganizations</option>
      <option v-for="subOrg in subOrgFilterOptions" :key="subOrg.id" :value="String(subOrg.id)">{{ subOrg.name }}</option>
    </select>
    <select :value="selectedLifecycleFilter" class="form-select" data-testid="users-lifecycle-filter" @change="emit('update:selectedLifecycleFilter', $event.target.value)">
      <option value="all">All lifecycle states</option>
      <option value="active">Active only</option>
      <option value="deleted">Read-only / deleted context</option>
    </select>
    <select class="form-select" :value="String(listPageSize)" data-testid="users-page-size" @change="emit('update:listPageSize', $event.target.value)">
      <option value="25">25 / page</option>
      <option value="50">50 / page</option>
      <option value="100">100 / page</option>
    </select>
  </div>
</template>

